import DashboardsMain from '../../dashboards/main/DashboardsMain'
import NavLinkPropsWithElement from '../../global/types/NavLinkPropsWithElement'
import Holidays from '../../holidays/components/main/HolidaysMain'
import ReportsMain from '../../reports/components/main/ReportsMain'
import AppointmentsMain from '../../schedule/components/main/AppointmentsMain'
import UserManagement from '../../user-management/main/UserManagementMain'
import VansMain from '../../vans/main/VansMain'
import WorkOrders from '../../work-orders/components/main/WorkOrdersMain'
import { RequireAuth } from '../components/auth/RequireAuth'
import { ROLES } from '../constants/users'
const linksData: Array<NavLinkPropsWithElement> = [
  {
    to: '/',
    title: 'Schedule',
    element: (
      <RequireAuth>
        <AppointmentsMain />
      </RequireAuth>
    ),
  },
  {
    to: '/work-orders',
    title: 'Work Orders',
    element: (
      <RequireAuth>
        <WorkOrders />
      </RequireAuth>
    ),
  },
  {
    to: '/vans',
    title: 'Vans',
    element: (
      <RequireAuth>
        <VansMain />
      </RequireAuth>
    ),
  },
  {
    to: '/holidays',
    title: 'Holidays',
    permissionLevels: [
      ROLES.ADMIN,
      ROLES.SUPER_ADMIN,
      ROLES.CALL_CENTER_REPRESENTATIVE,
    ],
    element: (
      <RequireAuth>
        <Holidays />
      </RequireAuth>
    ),
  },
  {
    to: '/reports',
    title: 'Reports',
    element: (
      <RequireAuth>
        <ReportsMain />
      </RequireAuth>
    ),
  },
  {
    to: '/dashboards',
    title: 'Dashboards',
    element: (
      <RequireAuth>
        <DashboardsMain />
      </RequireAuth>
    ),
  },
  {
    to: '/user-management',
    title: 'User Management',
    permissionLevels: [ROLES.SUPER_ADMIN],
    element: (
      <RequireAuth>
        <UserManagement />
      </RequireAuth>
    ),
  },
]

export default linksData
